import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { domainActions } from '../../../../store/domainStore';
import { isNullOrUndefined } from '../../../../store/storeFunctions';
import { repiActions, dataCorrectionType, repiDomain } from '../../../../store/repiStore';
import RepiDataCorrectionInputField from './repiDataCorrectionInputField';

import '../../repi.scss';
import { isString } from 'lodash';

class RepiDataCorrectionTableColumn extends React.Component {
    render() {
        const { isHeader, sectionId, name, label, type, value, error, rowId, isNew, isPending, setFieldValue,
            noMaxDate, textOnly, enableDateReinitialize, afterDateReinitialized, contractId } = this.props;

        const errorMessage = isNullOrUndefined(error) || isString(error) ? error : error.message;
        const isWarning = isNullOrUndefined(error) || isString(error) ? false : error.isWarning;

        if (isHeader === true) {
            return (
                <td
                    key={`${sectionId}-${name}-header`}
                    className={classnames("repi-data-correction-table-header-cell bold",
                        { "narrow": type === dataCorrectionType.bool, "center": type === dataCorrectionType.bool }
                    )}
                >
                    <div><Translate id={label} /></div>
                </td>
            );
        }

        if (textOnly === true) {
            let textValue = value;
            if (type === dataCorrectionType.bool)
            textValue = value === true ? "T" : "F";

            return (
                <td className={classnames("repi-data-correction-table-cell", { "center": type === dataCorrectionType.bool })}>
                    {textValue}
                </td>
            );
        }

        return (
            <td className={classnames("repi-data-correction-table-cell", { "center": type === dataCorrectionType.bool })}>
                <RepiDataCorrectionInputField
                    name={name}
                    rowId={rowId}
                    value={value}
                    error={errorMessage}
                    sectionId={sectionId}
                    setFieldValue={setFieldValue}
                    type={type}
                    isNew={isNew}
                    isPending={isPending}
                    options={type === dataCorrectionType.list ? this.getListForDropDown() : undefined}
                    placeholder={<div></div>}
                    noMaxDate={noMaxDate}
                    enableDateReinitialize={enableDateReinitialize}
                    afterDateReinitialized={afterDateReinitialized}
                    contractId={contractId}
                    isWarning={isWarning}
                />
            </td>
        )
    }

    getListForDropDown = () => {
        const { domain, domainKey, domainEmpty } = this.props;
        if (isNullOrUndefined(domain) || isNullOrUndefined(domain[domainKey]) || isNullOrUndefined(domain[domainKey].requestResult))
            return [];

        const codes = domain[domainKey].requestResult;
        if (codes.length === 0)
            return [];

        const result = isNullOrUndefined(domainEmpty) ? [] : [{ value: domainEmpty, lavel: "", code: "" }];

        return [ ...result, ...codes.map(code => ({
            value: parseInt(code.value),
            label: domainKey === repiDomain.dunningLevels ? this.props.translate(`Repi.DunningLevel.${code.shortening}`) : code.shortening,
            code: code.shortening
        })).filter(f => !isNaN(f.value))];
    }
}

export default connect(
    state => ({ domain: state.domain }),
    dispatch => bindActionCreators({...repiActions, ...domainActions}, dispatch)
)(withLocalize(RepiDataCorrectionTableColumn));
